const parse = (item: any): any => ({
  text: item.value,
  value: item.value,
});

const parseList = (list: any): any => {
  return list.map(parse);
};

export default parseList;



// WEBPACK FOOTER //
// ./src/services/dadata/utils/parseList.ts